import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AccordionComponent, ExpandEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DialogComponent, TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { Subject, Subscription } from 'rxjs';
import { ILLKit, ILLProduct } from '../../shared/models/index';


@Component({
    selector: 'app-sidebar-products',
    templateUrl: './sidebar-products.component.html',
    styleUrls: ['./sidebar-products.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class SidebarProductsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  sbmodalValWidth = '500px';
  sbmodalValHeight = 'auto';
  public sbmodalValVisible = true;
  public sbmodalValHidden = false;
  animationSettings: Object = { effect: 'Zoom' };
  position: object = { X: 'center', Y: 'center' };
  isModal = true;
  PROD_TYPE_KIT = 'RTCD_LLKit';

  @Output() productIndex = new EventEmitter<any>();
  @Output() partIndex = new EventEmitter<any>();
  @Output() productToDelete = new EventEmitter<any>();
  @Output() cloneProductIndex = new EventEmitter<any>();
  @Output() scrollToElementOutput = new EventEmitter<any>();

  @Input() formData: any;
  @Input() formProdIndex = 0;
  @Input() partIndexInput: number;
  @Input() proprietaryNameInput;
  @Input() isPartInput = false;

  products: ILLProduct[] = [];
  product: ILLProduct;
  currentIndex = 0;
  currentPartIndex = 0;
  addedPartIndex = -1;
  deletedProdIndex = -1;
  deleteProductLinks: any;
  enablePersistence = false;
  sub: Subscription;
  isPart = false;

  @ViewChild('productsAccordion') productsAccordion: AccordionComponent;

  @ViewChild('sbModalDialog')
  public sbModalDialog: DialogComponent;

  @ViewChild('confirmDeleteDialog')
  public confirmDeleteDialog: DialogComponent;

  tooltipObjPart: TooltipComponent;
  tooltipObj: TooltipComponent;

  public clickEventArgs: Event;

  confirmDeleteDlgSelection$: Subject<boolean> = new Subject<boolean>();


  public encodeHtml(str) {
    const buf = [];
    if (str) {
      for (let i = str.length - 1; i >= 0; i--) {
        buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
      }

      return buf.join('');
    }
  }

  public decodeHtml(str) {

    if (str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    }
  }

  deleteDlgBtnYes: EmitType<object> = () => {

    this.confirmDeleteDialog.hide();

    this.productToDelete.emit(this.deletedProdIndex);

    this.products = this.formData[0].data.products;

    this.deletedProdIndex = -1;
    this.selectProduct(0);
    this.productsAccordion.refresh();
  }

  deletedDlgBtnNo: EmitType<object> = () => {

    const splInput = document.getElementById('splVersionModalInput');

    this.confirmDeleteDialog.hide();
  }


  // eslint-disable-next-line @typescript-eslint/member-ordering
  confirmDeleteDlgButtons: Object[] = [{ click: this.deletedDlgBtnNo.bind(this), buttonModel: { content: 'Cancel' } }, { click: this.deleteDlgBtnYes.bind(this), buttonModel: { content: 'Continue', isPrimary: true } } ];


  constructor (private cdref: ChangeDetectorRef, private sanitizer: DomSanitizer) { }

  dlgButtonClick: EmitType<object> = () => {
    this.sbModalDialog.hide();
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public buttons: Object[] = [{ click: this.dlgButtonClick.bind(this), buttonModel: { content: 'OK', isPrimary: true } }];

  ngAfterViewInit(): void {

    this.productsAccordion.select(this.formProdIndex);

    this.productsAccordion.items.forEach(item => {

      item.cssClass = 'accordionItemCss';
    });
  }

  ngOnInit() {

    if (this.sbModalDialog) {
      this.sbModalDialog.hide();
    }

    if (this.formData) {

      this.products = this.formData[0].data.products;

      this.product = this.products[this.formProdIndex];
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    // eslint-disable-next-line guard-for-in
    for (const property in changes) {

      switch (property) {

        case 'formProdIndex':

          if (changes[property].currentValue || changes[property].currentValue === 0) {

            this.formProdIndex = changes[property].currentValue;

            if (this.formProdIndex) {

              this.product = this.products[this.formProdIndex];
            }

            this.clearPartsActive();
          }

          break;

        case 'proprietaryNameInput':

          if (changes[property].currentValue) {

            if (this.isKit()) {

              // check if any part active, meaning the part is opened in a form, not a kit
              if (!this.isAnyPartActive()) {

                // since the parts were removed from the sidebar display this line is not needed
                // this.products[this.formProdIndex].proprietaryName = changes[property].currentValue;
              } else {

                (this.products[this.formProdIndex] as ILLKit).parts[this.currentPartIndex].proprietaryName = changes[property].currentValue;

              }
            } else {

              // not a kit
              this.products[this.formProdIndex].proprietaryName = changes[property].currentValue;
            }
          }

          break;

        case 'partIndexInput':

          if (changes[property].currentValue || changes[property].currentValue === 0) {
            this.selectPart(changes[property].currentValue);

            this.currentPartIndex = changes[property].currentValue;
          }

          break;

        case 'addedPartIndex':

          if (changes[property].currentValue || changes[property].currentValue === 0) {
            this.selectPart(changes[property].currentValue);

            this.currentPartIndex = changes[property].currentValue;
          }

          break;

        case 'isPartInput':

          this.isPart = changes[property].currentValue;

        break;
      }
    }

  }

  isKit() {

    let product;

    if (this.formProdIndex >= 0 && this.formProdIndex <= this.products.length - 1) {

      product = this.products[this.formProdIndex];

      if (product.$type  === this.PROD_TYPE_KIT) {
        return true;
      }
    }

    return false;
  }

  public expanding(e: ExpandEventArgs) {

    if (this.currentIndex === e.index) {

      if (this.isKit()) {

        if (this.isAnyPartActive()) {

          this.clearPartsActive();
          e.cancel = true;
        }
      }
    }

    if (e.isExpanded) {
      if (this.currentIndex !== e.index) {
        this.productsAccordion.expandItem(false, e.index);
      }
      this.productIndex.emit({ oldIndex: this.currentIndex, newIndex: e.index });
      this.currentIndex = e.index;
    } else {

      if (this.currentIndex === e.index || this.isKit()) {
        this.productIndex.emit({ oldIndex: this.currentIndex, newIndex: e.index });
      }
    }
  }

  showPart(index) {
    this.currentPartIndex = index;
    this.partIndex.emit({ partIndex: index, prodIndex: this.currentIndex });
  }

  clearPartsActive() {

    const parts = document.getElementsByClassName('part-name');

    const partsArray = Array.from(parts);

    if (partsArray && partsArray.length > 0) {

      partsArray.forEach(part => {

        if (part.classList.contains('active')) {

          part.classList.remove('active');
        }
      });
    }
  }

  isAnyPartActive() {

    const parts = document.getElementsByClassName('part-name');

    const partsArray = Array.from(parts);

    const active = partsArray.filter(p => p.classList.contains('active'));

    return active ? active.length > 0 : false;
  }

  selectPart(index) {

    this.clearPartsActive();

    const partDiv = document.getElementById(`part-${this.formProdIndex}-${ index }`);

    if (partDiv) {
      partDiv.classList.add('active');
    }
  }

  // this function is called from ll-form switchPart for the new part.
  // it should be executed only after the new part is rendered
  addedPart(index) {

    this.addedPartIndex = index;
    this.cdref.detectChanges();
  }

  accordionCreated(event) {
    this.productsAccordion.expandItem(true, 0);
  }

  collapseItem(index) {
    this.productsAccordion.expandItem(false, index);
  }

  public cloneProduct() {
    this.cloneProductIndex.emit(this.currentIndex);
  }

  showProduct(index) {

    this.productIndex.emit({ oldIndex: this.currentIndex, newIndex: index });
    this.currentIndex = index;
    this.productsAccordion.expandItem(true, index);
  }

  selectProduct(index) {

    this.productsAccordion.select(index);

    this.currentIndex = index;

    this.showProduct(index);
  }


  deleteProduct(index) {

      // The last product can not be deleted
      if (this.products.length === 1) {
        this.sbModalDialog.show();
      } else {
        this.deletedProdIndex = index;
        // show modal for setting a version and cancel the build if Cancel is seleced.
        this.confirmDeleteDialog.show();
    }
  }

  onOverlayClick() {
    this.sbModalDialog.hide();
    this.sbmodalValVisible = false;
  }


  onOverlayDeleteDlgClick() {
    this.confirmDeleteDialog.hide();
  }

  showToolTip(event) {

    if (this.isEllipsisActive(event)) {

      event.target.setAttribute('title', event.target.textContent);
    }
  }

  showSFToolTip(event) {
    if (this.isEllipsisActive(event)) {
      this.tooltipObj = event.target?.parentElement?.ej2_instances?.length > 0 ? event.target.parentElement?.ej2_instances[0] : undefined;
      if (this.tooltipObj) {
        this.tooltipObj.content = event.target.outerText;
        this.tooltipObj.width = `${ event.target.scrollWidth }px`;

        this.tooltipObj.open();
      }
    }
  }

  hideSFToolTip(event) {

    if (this.tooltipObj) {

      this.tooltipObj.close();
    }
  }

  showSFToolTipPart(event) {
    if (this.isEllipsisActive(event)) {
      this.tooltipObj = event.target?.parentElement?.ej2_instances?.length > 0 ? event.target.parentElement?.ej2_instances[0] : undefined;

      if (this.tooltipObjPart) {
        this.tooltipObjPart.content = event.target.outerText;
        this.tooltipObjPart.width = `${ event.target.scrollWidth }px`;

        this.tooltipObjPart.open();
      }
    }
  }

  hideSFToolTipPart(event) {

    if (this.tooltipObjPart) {

      this.tooltipObjPart.close();
    }
  }

  isEllipsisActive(e) {
    return (e.target.offsetWidth < e.target.scrollWidth);
  }

  scrollToElement(element) {

    this.scrollToElementOutput.emit(element);
  }

  ngOnDestroy(): void {

    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
